import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { useNetworkStatus, useScroll } from "share/hooks";
import { Detector } from "react-detect-offline";
import { render } from "@testing-library/react";
import { getBrowserDetails } from "analytics";
import NoInternetIcon from "assets/ntat/icons/no-internet.svg";

export const NoInternet = styled.h3`
  color: transparent;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  margin: 0;
  font-family: Poppins;
  padding: 15px 0;
  ${({ isOnline }) =>
    !isOnline &&
    css`
      color: #2b2928;
    `}
`;
export const NoInternetContainer = styled.div`
  max-height: 0;
  background-color: #fef2f1;
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
  width: 100%;
  z-index: 101;
  overflow: hidden;
  ${({ isOnline }) =>
    !isOnline &&
    css`
      max-height: 48px;
    `}
  transition:max-height 1s ease;
`;

export default function NoInternetComponent() {
  const isFireFox = getBrowserDetails().includes("Firefox");
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  useEffect(() => {
    const interval = setInterval(() => {
      setIsOnline(window.navigator.onLine);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return (
    <NoInternetContainer isOnline={isOnline}>
      <img src={NoInternetIcon} alt="" />
      <NoInternet isOnline={isOnline}>No Internet Connection!</NoInternet>
    </NoInternetContainer>
  );
}
